import useT from "../../utils/useT"
import { BsCheckCircleFill, BsSignpost2, BsStars } from "react-icons/bs"
import useGlobalStore from "../../stores/global"
import useUnsavedStore from "../../stores/unsaved"
import useRouterStore from "stores/routerStore"
import useSessionStore from "stores/session"
import { MdNotificationsActive } from "react-icons/md"
import useNotifications from "utils/useNotifications"
import { event } from "utils/gtag"
import useStandalone from "utils/useStandalone"
import useSnackbarStore from "stores/snackbar"

const SettingsCard = () => {
  const t = useT()
  const { isStandalone } = useStandalone({})
  const { subscribe, isLoading } = useNotifications()
  const isSubscribedToNotifications = useGlobalStore(
    (state) => state.isSubscribed,
  )

  const locale = useRouterStore((state) => state.router?.locale)
  const isAdmin = useSessionStore((state) => state.user.isAdmin)

  const animationToggle = useGlobalStore((state) => state.animationToggle)
  const setAnimation = useGlobalStore((state) => state.setAnimation)

  const appearance = useGlobalStore((state) => state.appearance)

  const transparency = useGlobalStore((state) => state.transparency)
  const setTransparency = useGlobalStore((state) => state.setTransparency)

  const showAds = useGlobalStore((state) => state.showAds)
  const setShowAds = useGlobalStore((state) => state.setShowAds)

  const translateSubmitterNote = useGlobalStore(
    (state) => state.translateSubmitterNote,
  )
  const setTranslateSubmitterNote = useGlobalStore(
    (state) => state.setTranslateSubmitterNote,
  )
  const toggleAppearanceSheet = useUnsavedStore(
    (state) => state.toggleAppearanceSheet,
  )
  const toggleLanguageSheet = useUnsavedStore(
    (state) => state.toggleLanguageSheet,
  )

  const toggleSnackbar = useSnackbarStore((state) => state.toggleSnackbar)

  const AppearanceIcon = () => {
    switch (appearance) {
      case "Dark":
        return { icon: "fa-moon color-white", name: t.settings.dark }
      case "Light":
        return { icon: "color-yellow-dark fa-sun", name: t.settings.light }
      case "Auto":
        return { icon: "color-green-light fa-magic", name: t.settings.auto }

      default:
        return { icon: "color-green-light fa-magic", name: t.settings.notSet }
    }
  }
  const languages = () => {
    switch (locale) {
      case "en":
        return {
          name: "English",
          src: "/flags/uk.svg",
        }
      case "ar":
        return {
          name: "العربية",
          src: "/flags/iq.svg",
        }
      case "tr-TR":
        return {
          name: "Türkçe",
          src: "/flags/tr.svg",
        }
      case "":
        return {
          name: "English",
          src: "/flags/uk.svg",
        }

      default:
        return {
          name: "English",
          src: "/flags/uk.svg",
        }
    }
  }
  const shareSheet = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Share Appollow app link",
          url: "https://www.appollow.net",
        })
        .then(() => {
          console.log("Thanks for sharing!")
        })
        .catch(console.error)
    } else {
      console.log("WebShare API not supported.")
    }
  }
  return (
    <div className="card card-style">
      <div className="content mt-0 mb-2">
        <div className="list-group list-custom-large">
          <a onClick={toggleAppearanceSheet} data-menu="menu-highlights">
            <i className="fa font-14 fa-brush bg-highlight color-white rounded-sm"></i>
            <b>{t.settings.appearance}</b>
            <strong>{t.settings.appearanceSub}</strong>
            <div className="me-2 float-end d-flex align-items-center">
              <i className={`fa ${AppearanceIcon().icon} me-0 mt-0`}></i>
              <span>{AppearanceIcon().name}</span>
            </div>
          </a>
          <a
            onClick={() => {
              toggleLanguageSheet()
              event({
                action: "language_toggle_click",
                category: "Settings",
                label: "language setting clicked",
              })
            }}
            data-menu="menu-language"
          >
            <i className="fa font-14 fa-globe bg-green-dark rounded-sm"></i>
            <b>{t.settings.languagePicker}</b>
            <strong>{t.settings.languagePickerSub}</strong>
            <div className="me-2 float-end">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                style={{ width: 25, height: 25 }}
                src={languages().src}
                alt="language"
              />
              <span>{languages().name}</span>
            </div>
          </a>
          <a className="pb-4">
            <i className="font-14 bg-yellow-dark rounded-sm">
              <MdNotificationsActive />
            </i>
            <b>{t.settings.notifications}</b>
            <strong>{t.settings.notificationsSub}</strong>
            <div className="custom-control scale-switch ios-switch">
              {isSubscribedToNotifications ? (
                <i
                  className="font-34 mt-2 "
                  onClick={() =>
                    event({
                      action: "notification_check_click",
                      category: "Settings",
                      label: "notification check icon clicked",
                    })
                  }
                >
                  <BsCheckCircleFill color="#8cc152" />
                </i>
              ) : isLoading ? (
                <i className="mt-2">
                  <span
                    className="spinner-border spinner-border-md"
                    role="status"
                  />
                </i>
              ) : (
                <>
                  <input
                    type="checkbox"
                    className="ios-input"
                    id="switch-noti"
                    checked={isSubscribedToNotifications}
                    onClick={() => {
                      isStandalone
                        ? subscribe()
                        : toggleSnackbar({
                            color: "yellow",
                            text: t.notifications.installPWAFirst,
                          })
                      event({
                        action: "notification_toggle_click",
                        category: "Settings",
                        label: "notification setting clicked",
                      })
                    }}
                    disabled={isLoading}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="switch-noti"
                  ></label>
                </>
              )}
            </div>
          </a>
          <a className="pb-4">
            <i className="font-14 fas fa-language bg-yellow-dark rounded-sm"></i>
            <b>{t.settings.translateSubmitterNote}</b>
            <strong>{t.settings.translateSubmitterNoteSub}</strong>
            <div className="custom-control scale-switch ios-switch">
              <input
                type="checkbox"
                className="ios-input"
                id="switch-1"
                checked={translateSubmitterNote}
                onChange={(e) => {
                  setTranslateSubmitterNote(e.currentTarget.checked)
                  event({
                    action: "TranslateSubmitterNote_toggle_click",
                    category: "Settings",
                    label: "TranslateSubmitterNote setting clicked",
                    value: e.currentTarget.checked + "",
                  })
                }}
              />
              <label
                className="custom-control-label"
                htmlFor="switch-1"
              ></label>
            </div>
          </a>
          <a className="pb-4">
            <i className="font-14 fas fa-palette bg-pink-dark rounded-sm"></i>
            <b>{t.settings.appAnimation}</b>
            <strong>{t.settings.appAnimationSub}</strong>
            <div className="custom-control scale-switch ios-switch">
              <input
                type="checkbox"
                className="ios-input"
                id="switch-2"
                checked={animationToggle}
                onChange={(e) => {
                  setAnimation(e.currentTarget.checked)
                  event({
                    action: "animation_toggle_click",
                    category: "Settings",
                    label: "animation setting clicked",
                    value: e.currentTarget.checked + "",
                  })
                }}
              />
              <label
                className="custom-control-label"
                htmlFor="switch-2"
              ></label>
            </div>
          </a>

          <a className="pb-4">
            <i className="font-14 bg-orange-dark rounded-sm">
              <BsStars />
            </i>
            <b>{t.settings.transparency}</b>
            <strong>{t.settings.transparencySub}</strong>
            <div className="custom-control scale-switch ios-switch">
              <input
                type="checkbox"
                className="ios-input"
                id="transparency-switch"
                checked={transparency}
                onChange={(e) => {
                  setTransparency(e.currentTarget.checked)
                  event({
                    action: "transparency_toggle_click",
                    category: "Settings",
                    label: "transparency setting clicked",
                    value: e.currentTarget.checked + "",
                  })
                }}
              />
              <label
                className="custom-control-label"
                htmlFor="transparency-switch"
              ></label>
            </div>
          </a>
          {isAdmin && (
            <a className="pb-4">
              <i className="font-14 bg-teal-dark rounded-sm">
                <BsSignpost2 />
              </i>
              <b>Show ads</b>
              <strong>Toggle showing ads for admins</strong>
              <div className="custom-control scale-switch ios-switch">
                <input
                  type="checkbox"
                  className="ios-input"
                  id="show-ads-switch"
                  checked={showAds}
                  onChange={(event) => setShowAds(event.currentTarget.checked)}
                />
                <label
                  className="custom-control-label"
                  htmlFor="show-ads-switch"
                ></label>
              </div>
            </a>
          )}
          <a className="border-0" onClick={shareSheet}>
            <i className="fa font-14 fa-share-alt bg-red-dark rounded-sm"></i>
            <b>{t.settings.share}</b>
            <strong dir="auto">{t.settings.shareSub}</strong>
            <i className="fa fa-angle-right me-2"></i>
          </a>

          {/* <a href="index-shapes.html">
              <i className="far font-14 fa-heart bg-pink-dark rounded-sm"></i>
              <b>Azures Shapes</b>
              <strong>Header and Footer Shapes</strong>
              <i className="fa fa-angle-right me-2"></i>
            </a> */}
          {/* <a href="#" data-menu="menu-tips-1" className="border-0">
            <i className="fa font-14 fa-gift bg-magenta-light rounded-sm"></i>
            <b>Tap Here to Start</b>
            <strong>A few Tips About Appollow</strong>
            <i className="fa fa-angle-right me-2"></i>
          </a> */}
        </div>
      </div>
    </div>
  )
}

export default SettingsCard
